import { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';

/**
 * Small per-section data loader for the Customer 365 tabs. GETs a route and
 * exposes { data, loading, error } with the app's standard cancellation guard,
 * so each section loads and fails independently. Re-runs when `route`,
 * `enabled`, or `refreshKey` change.
 */
export default function useResource(route, { enabled = true, refreshKey } = {}) {
  const jApi = useApi();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(!!enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !route) { setLoading(false); return undefined; }
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const resp = await jApi.request('GET', route);
        if (!cancelled) setData(resp.data);
      } catch (ex) {
        if (!cancelled) setError(ex?.response?.data?.error?.message || ex?.toString?.() || 'Request failed');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, enabled, refreshKey]);

  return { data, loading, error };
}
